export interface WebchatHeading {
  title?: string;
  subtitle?: string;
  icon?: string;
}

export interface WebchatHomePage {
  panels: HomePanelConfig[];
}

export interface HomePanelConfig {
  icon?: string;
  title?: string;
  allowAnonymous?: boolean;
  visibilityRule?: "no_chat_hide" | "chat_hide";
  items: HomePanelItem[];
}

export interface HomePanelItemGroup {
  type: "group";
  title: string;
  items: HomePanelItem[];
  allowAnonymous?: boolean;
}

export interface HomePanelItemLink {
  type: "link";
  text: string;
  url: string;
}

export interface HomePanelItemSend {
  type: "send";
  text: string;
  disableQuery?: boolean;
  hideIfNoChat?: boolean;
}

export type HomePanelItem =
  | string
  | HomePanelItemGroup
  | HomePanelItemLink
  | HomePanelItemSend;

export function isHomePanelItemGroup(
  item: HomePanelItem
): item is HomePanelItemGroup {
  return (item as HomePanelItemGroup).type === "group";
}

export function isHomePanelItemLink(
  item: HomePanelItem
): item is HomePanelItemLink {
  return (item as HomePanelItemLink).type === "link";
}

export function isHomePanelItemSend(
  item: HomePanelItem
): item is HomePanelItemSend {
  return (item as HomePanelItemSend).type === "send";
}
